
import {catchError, map, switchMap} from 'rxjs/operators';
import {Component, OnInit, } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Attachment} from '../../../common/model/attachment.model';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Base} from '../../../common/model/base.model';
import {ConfigService} from '../../../core/config.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {ErrorObservable} from 'rxjs-compat/observable/ErrorObservable';
import {ApiMessageService} from '../../../core/api-message.service';
import {CommonService} from '../../../common/controller/common.service';
import {Permission} from '../../../common/model/permission.enum';

@Component({
    selector: 'app-attachment-modal',
    template: `
      <div class="modal-header alert-info">
        <h4 *ngIf="entity" class="modal-title pull-left text-truncate">Gestione allegati per {{ entity.getLabel() }}</h4>
        <h4 *ngIf="!entity" class="modal-title pull-left text-truncate">Gestione allegati</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered">
          <thead class="thead-light">
          <tr class="">
            <th scope="col">Nome</th>
            <th scope="col">Descrizione</th>
            <th *ngIf="deleteEnabled" scope="col">Elimina</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let attachment of attachments">
              <td>
                <div class="d-flex">
                  <a class="btn btn-link mr-auto" (click)="getBlob(attachment.key, attachment.filename, false)">{{ attachment.filename }}</a>
                  <button class="btn btn-link" (click)="getBlob(attachment.key, attachment.filename, true)" [disabled]="disabled">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td>{{ attachment.description }}</td>
              <td class="text-center" *ngIf="deleteEnabled">
                <button class="btn btn-outline-danger btn-xs pt-0 pb-0" (click)="onDelete(attachment.key)" [disabled]="disabled">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="attachmentForm && uploadEnabled" class="card bg-light mt-5">
          <h5 class="d-inline-block p-3"><i class="fa fa-paperclip"></i> Aggiungi allegato</h5>

          <form [formGroup]="attachmentForm" (ngSubmit)="onSubmit()">
            <app-control-attachment formControlName="file" [disabled]="disabled"></app-control-attachment>
            <app-control-text formControlName="descr" [disabled]="disabled"></app-control-text>
            <app-buttons-layout class="d-flex justify-content-end pb-2">
              <app-button-save [disable]="disabled"></app-button-save>
            </app-buttons-layout>
          </form>
        </div>

      </div>
    `,
    styles: [],
    standalone: false
})
export class AttachmentModalComponent implements OnInit {

  entity: Base;

  attachments: Attachment[];

  attachmentForm: FormGroup;

  serviceAttachment: CommonService<any>;
  
  uploadEnabled: boolean = true;

  deleteEnabled: boolean = true;

  disabled: boolean = false;

  constructor(public modalRef: BsModalRef,
              protected apiMessageService: ApiMessageService) {}

  ngOnInit() {
    if (!this.attachments) {
      this.serviceAttachment.getFiles(this.entity).subscribe(files => {
        this.attachments = files;
      });
    }
    this.attachmentForm = new FormGroup({
        file: new FormControl(null),
        descr: new FormControl(null)
      }
    );
    this.uploadEnabled = this.uploadEnabled && this.entity.hasPermission(Permission.UPDATE);
  }

  onSubmit() {
    this.disabled = true;
    this.serviceAttachment.postFile(this.entity, this.attachmentForm.value.file, this.attachmentForm.value.descr).subscribe( (result) => {
      this.serviceAttachment.getFiles(this.entity).subscribe(files => {
        this.attachments = files;
        this.attachmentForm = new FormGroup({
          file: new FormControl(null),
          descr: new FormControl(null)
        }
      );
      this.disabled = false;
      });
    });
  }

  onDelete(key: string) {
    this.disabled = true;
    this.serviceAttachment.deleteFile(this.entity,key).subscribe((result) => {
      this.serviceAttachment.getFiles(this.entity).subscribe(files => {
        this.attachments = files;
        this.disabled = false;
      });
    });
  }

  getBlob(key: string, filename: string, download: boolean) {
    return this.serviceAttachment.getBlob(this.entity, key, filename, download);
  }

}

